// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tabelaGeral__ZDkaH {
  padding: 0px;
}

.styles_tabelaHeader__\\+ycgg {
  font-family: "Inter" !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding-top: 2px !important;
  padding-bottom: 4px !important;
}

.styles_iconeEditar__tNImx {
  color: #18316e !important;
}

.styles_iconeEditar__tNImx:hover {
  transform: scale(0.95) !important;
}

.styles_iconeExcluir__W9HFm {
  color: #ff0000 !important;
  margin-left: 4% !important;
}

.styles_iconeAtivo__ReMyO {
  width: 20px !important;
  height: auto !important;
}

.styles_boxAcoes__uJY5a {
  vertical-align: middle !important;
}

.styles_customCell__M5IAm {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  font-family: "Inter" !important;
  color: #000000 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/TabelaDinamicaPermissao/styles.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,yBAAyB;AAC3B","sourcesContent":[".tabelaGeral {\n  padding: 0px;\n}\n\n.tabelaHeader {\n  font-family: \"Inter\" !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  padding-top: 2px !important;\n  padding-bottom: 4px !important;\n}\n\n.iconeEditar {\n  color: #18316e !important;\n}\n\n.iconeEditar:hover {\n  transform: scale(0.95) !important;\n}\n\n.iconeExcluir {\n  color: #ff0000 !important;\n  margin-left: 4% !important;\n}\n\n.iconeAtivo {\n  width: 20px !important;\n  height: auto !important;\n}\n\n.boxAcoes {\n  vertical-align: middle !important;\n}\n\n.customCell {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  font-family: \"Inter\" !important;\n  color: #000000 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabelaGeral": `styles_tabelaGeral__ZDkaH`,
	"tabelaHeader": `styles_tabelaHeader__+ycgg`,
	"iconeEditar": `styles_iconeEditar__tNImx`,
	"iconeExcluir": `styles_iconeExcluir__W9HFm`,
	"iconeAtivo": `styles_iconeAtivo__ReMyO`,
	"boxAcoes": `styles_boxAcoes__uJY5a`,
	"customCell": `styles_customCell__M5IAm`
};
export default ___CSS_LOADER_EXPORT___;
